import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApiErrorTrackerService {
  private consecutiveFailures = 0;
  private readonly MAX_FAILURES = 5;

  recordFailure(): boolean {
    this.consecutiveFailures++;
    return this.consecutiveFailures >= this.MAX_FAILURES;
  }

  recordSuccess() {
    this.consecutiveFailures = 0;
  }
}
